import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import account from './account/accountReducer';
import asset from './asset/assetReducer';
import baremetal from './baremetal/reducer';
import contact from './contact/contactReducer';
import market from './market/reducer';
import network from './network/networkReducer';
import product from './product/productReducer';
import project from './project/projectReducer';
import server from './server/serverReducer';
import sslCertificate from './ssl/certificate/sslCertificateReducer';
import storm from './storm/stormReducer';
import usertask from './usertask/usertaskReducer';
import utilities from './utilities/utilitiesReducer';

export default combineReducers({
	account,
	asset,
	baremetal,
	contact,
	form,
	market,
	network,
	product,
	project,
	server,
	sslCertificate,
	storm,
	usertask,
	utilities,
});
